<template>
  <form @submit.prevent="submit">
    <fields :model="model" :errors="errors" ungrouped />

    <div class="form-group row">
      <label for="driver_rating" class="col-sm-4 col-form-label text-sm-right">
        {{ $t('reviews.label_driver_rating') }}
      </label>
      <div class="col-sm-8">
        <a :href="'#/' + base + '/' + id + '/reviews/'" class="btn btn-primary">
          {{ $t('reviews.btn_driver_rating') }}
        </a>
      </div>
    </div>

    <hr />
    <fields group="password" />

    <div class="form-group">
      <b-button type="submit" variant="primary">
        {{ $t('general.save') }}
      </b-button>
      <b-button type="button" variant="light" class="ml-2" @click="cancel">
        {{ $t('general.cancel') }}
      </b-button>
    </div>
  </form>
</template>

<script>
import { ResourceFormMixin } from 'stylemix-vue-admin'
import DriversApi from './Api'

export default {
  name: 'DriverForm',

  mixins: [ResourceFormMixin],

  data() {
    return {
      base: 'drivers',
    }
  },

  mounted() {
    this.loadForm()
  },

  methods: {
    api() {
      return new DriversApi().setParameters({
        division_id: this.currentDivision.id,
      })
    },

    submit() {
      this.save().then(() => {
        this.$toast.success('Driver was saved successfully')
      })
    },
  },
}
</script>
